import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';
import { DEFAULT_PAGE_SIZE } from '@src/utils/constants';

export const CONTRACTOR_LOS_PATH = 'contractors/los/contractor';

export const modeOfTransportApi = createApi({
  reducerPath: 'modeOfTransportApi',
  tagTypes: ['ModeOfTransportApi'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getSingleModeOfTransport: builder.query({
      query: ({ id, pathName }) => ({
        url:
          pathName === 'company'
            ? `/v1/${pathName}/mode_of_transport/${id}`
            : `/v2/contractors/los/${id}`,
      }),
    }),

    getModeOfTransportTableData: builder.mutation({
      query: ({ argument, pathName, body = {}, params = {} }) => {
        const resolvedPathName = argument?.pathName ?? pathName;
        const requestParams = {
          sortBy: 'expirationDate',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        };

        return {
          // TODO check this!!! messing all the endpoints!!!
          url: `/${resolvedPathName.includes('payor') ? 'v1' : 'v2'}/${resolvedPathName}`,
          method: 'POST',
          body,
          params: requestParams,
        };
      },
    }),
    createOrUpdateModeOfTransport: builder.mutation({
      query: ({ data, pathname, method }) => ({
        url: `${pathname}`,
        method: method,
        body: data,
      }),
    }),
  }),
});

export const {
  useLazyGetSingleModeOfTransportQuery,
  // useGetModeOfTransportTableDataQuery,
  useGetModeOfTransportTableDataMutation,
  useCreateOrUpdateModeOfTransportMutation,
} = modeOfTransportApi;
